export const partnerSharesTypes = {
  ACTUAL: 'ACTUAL',
  FUTURE: 'FUTURE',
  DRAFTS: 'DRAFTS',
};
